export enum PlaygroundCompanyRoleEnum {
  C_LEVEL_EXECUTIVE = 'C-Level Executive',
  SOFTWARE_DEVELOPMENT = 'Software Development',
  QA_TEST = 'QA & Test',
  DEVOPS = 'DevOps',
  PRODUCT_MANAGEMENT = 'Product Management',
  OTHER = 'Other'
}
